<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <div class="orangehrm-login-layout">
    <div class="orangehrm-login-layout-blob">
      <div class="orangehrm-login-container">
        <div class="orangehrm-login-slot-wrapper">
          <div class="orangehrm-login-card">
            <div class="orangehrm-login-header">
              <a href="https://office.tiongmas.my" class="back-link">
                <oxd-icon name="chevronLeft" class="back-icon" />
                <span class="back-text">Back to Portal</span>
              </a>
              <login-branding
                :img-src="loginBannerSrc"
                class="custom-branding"
              ></login-branding>
              <div class="orangehrm-login-logo-mobile">
                <a href="https://office.tiongmas.my/HR">
                  <img :src="mynahBirdSrc" alt="orangehrm-logo" />
                </a>
              </div>
            </div>
            <div class="orangehrm-login-slot">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
      <div class="orangehrm-login-logo">
        <a href="https://office.tiongmas.my/HR">
          <img :src="mynahBirdSrc" alt="orangehrm-logo" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import LoginBranding from './LoginBranding';
import {OxdIcon} from '@ohrm/oxd';

export default {
  name: 'LoginLayout',
  components: {
    'login-branding': LoginBranding,
    'oxd-icon': OxdIcon,
  },
  props: {
    loginLogoSrc: {
      type: String,
      required: true,
    },
    loginBannerSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mynahBirdSrc: '/HR/web/images/tt-bulat.png',
    };
  },
};
</script>

<style lang="scss" scoped>
.orangehrm-login-layout {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #f2f2f2;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  @include oxd-respond-to('xs') {
    padding: 10px;
    align-items: flex-start;
    height: auto;
    min-height: 100vh;
  }
}

.orangehrm-login-layout-blob {
  width: 100%;
  display: flex;
  justify-content: center;
  &::before {
    display: none !important;
  }
  background: none !important;
}

.orangehrm-login-container {
  width: 100%;
  max-width: 480px;
  z-index: 1;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}

.orangehrm-login-card {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 30px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  @include oxd-respond-to('xs') {
    padding: 20px;
    margin: 40px auto 20px auto;
    max-width: 100%;
  }
}

.orangehrm-login-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  position: relative;
  width: 100%;
}

.back-link {
  position: absolute;
  left: 0;
  top: -60px; /* Move outside the card */
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #ffbf00;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.3s;

  &:hover {
    color: #e6ac00;
    text-decoration: none;
  }
}

.back-icon {
  margin-right: 8px;
  width: 20px;
  height: 20px;
  fill: currentColor;
}

::v-deep .orangehrm-login-branding.custom-branding {
  margin-bottom: 20px !important;
  max-width: 200px !important;
}

.orangehrm-login-logo-mobile {
  display: block;
  text-align: center;
  margin-bottom: 20px;

  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
    border-radius: 50%;
  }
}

.orangehrm-login-logo {
  display: none; /* Hide the side logo as we moved it inside/mobile style */
}

/* Adjust the slot (form) to fit well */
::v-deep .orangehrm-login-slot {
  padding: 0 !important;
  background-color: transparent !important;
}

/* Responsive */
@media (min-width: 992px) {
  .orangehrm-login-logo {
    display: block;
    position: absolute;
    right: 10%;
    top: 50%;
    transform: translateY(-50%);
    background: white;
    padding: 20px;
    border-radius: 50%;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

    img {
      width: 150px;
      height: 150px;
    }
  }

  .orangehrm-login-logo-mobile {
    display: none;
  }
}

@media (max-width: 768px) {
  .orangehrm-login-card {
    padding: 24px;
    margin: 20px;
  }
  .back-link {
    position: relative;
    top: 0;
    align-self: flex-start;
    margin-bottom: 20px;
  }
}
</style>
